import { render, staticRenderFns } from "./add-bar-form.vue?vue&type=template&id=6c097b2e&"
import script from "./add-bar-form.vue?vue&type=script&lang=ts&"
export * from "./add-bar-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports